package empiresmp.feature.shop.backend.model

import kotlinx.serialization.Serializable

@Serializable
enum class ServerType {
    SMP
}
